import assets from '@ps/bridge/qc/assets'
import qc from 'qc'
import gameIframe from '@ps/bridge/iframe/iframe'
import qcGame from '@ps/bridge/qc/qc-game'
import { AssetRoute } from '@ps/utils/config'
import { resetNodeDefaultLayout } from '@ps/bridge/qc/node/utils'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'

interface IAddDragonBoneParams {
  binUUID: string
  pid: number
  sceneNode: qc.Node
  nodeName: string
  name: string
}
interface IReplaceDragonBoneParams {
  binUUID: string
  pid: number
  activeNode: qc.Node
  nodeName: string
  name: string
}
export function getDragonBonePathPrefix(name: string) {
  return `${AssetRoute.GAME_ROOT}lg_${name}/`
}
export async function loadAssets({
  name,
  binUUID,
}: {
  name: string
  binUUID: string
}) {
  const pathPrefix = getDragonBonePathPrefix(name)
  const asset = await assets.load({
    uuid: binUUID,
    url: `${pathPrefix}${name}_${binUUID}.bin`,
    override: true,
  })
  return asset
}
export async function addDragonBoneNode({
  binUUID,
  pid,
  sceneNode,
  nodeName,
  name,
}: IAddDragonBoneParams) {
  const asset = await loadAssets({ name, binUUID })
  const newNode = qcGame.add.sprite(sceneNode)
  resetNodeDefaultLayout(newNode)
  newNode.name = nodeName || name
  const Texture = gameIframe.qc.Texture
  newNode.texture = new Texture(asset, 0)
  // 保存资源列表
  await saveGlobalUrlMap({
    projectKey: pid,
    uuid2url: assets.uuid2UrlConf,
  })
  return newNode
}

export async function replaceDragonBoneNode({
  binUUID,
  pid,
  nodeName,
  name,
  activeNode,
}: IReplaceDragonBoneParams) {
  const asset: any = await loadAssets({ name, binUUID })
  activeNode.name = nodeName || name
  await saveGlobalUrlMap({
    projectKey: pid,
    uuid2url: assets.uuid2UrlConf,
  })
  return asset
}

export function getDragonBoneDirectory(node: qc.Node): string | void {
  const url = node.texture.atlas.url
  if (url) {
    const arr = url.split(',')[0].split('/')
    arr.pop()
    return arr.join('/')
  }
}
